import ChartModel from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-model';
import ConnectorModel from '@src/slide/domain/ui-model/element-modeles/connector-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import GroupModel from '@src/slide/domain/ui-model/element-modeles/group-model';
import NoteModel from '@src/slide/domain/ui-model/element-modeles/note-model';
import PictureModel from '@src/slide/domain/ui-model/element-modeles/picture-model';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import TableModel from '@src/slide/domain/ui-model/element-modeles/table-model';
import SmartArtModel from '@src/slide/domain/ui-model/element-modeles/smart-art-model';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ElementModelType } from '@src/slide/domain/ui-model/element-modeles/factories/element-type';


export function createElementModel(type: ElementModelType): IElementBaseModel | undefined {
    switch (type) {
        case UIModelType.SHAPE:
            return new ShapeModel();
        case UIModelType.IMAGE:
            return new PictureModel();
        case UIModelType.GROUP:
            return new GroupModel();
        case UIModelType.CONNECTOR:
            return new ConnectorModel();
        case UIModelType.CHART:
            return new ChartModel();
        case UIModelType.NOTE:
            return new NoteModel();
        case UIModelType.TABLE:
            return new TableModel();
        case UIModelType.SMART_ART:
            return new SmartArtModel();
    }
}

export function getElementModelConstructorByType(type: ElementModelType): (new () => IElementBaseModel | undefined) {
    switch (type) {
        case UIModelType.SHAPE:
            return ShapeModel;
        case UIModelType.IMAGE:
            return PictureModel;
        case UIModelType.GROUP:
            return GroupModel;
        case UIModelType.SMART_ART:
            return SmartArtModel;
        case UIModelType.CONNECTOR:
            return ConnectorModel;
        case UIModelType.CHART:
            return ChartModel;
        case UIModelType.NOTE:
            return NoteModel;
        case UIModelType.TABLE:
            return TableModel;
    }
}

